<template>
  <div class="about-nconsulting-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <div class="min-height-300 bg-primary position-absolute w-100"></div>
    <page-hero
      title="N'Consulting"
      subtitle="Expertise en transformation digitale"
      description="Des consultants experts pour accompagner votre transformation numérique."
      :showBreadcrumb="true"
    />
    <main class="main-content position-relative border-radius-lg">
      <div class="container-fluid py-4">
        <div class="row">
          <div class="col-12 mb-4">
            <div class="card">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="d-flex flex-column h-100">
                      <h5 class="font-weight-bolder">N'Consulting : Votre partenaire transformation</h5>
                      <p class="mb-5">N'Consulting réunit des experts passionnés par l'innovation et la transformation digitale. Notre équipe accompagne les entreprises dans leur évolution numérique, de la stratégie à l'implémentation.</p>
                      <div class="features">
                        <h6 class="font-weight-bolder mb-3">Nos domaines d'expertise :</h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Audit et stratégie digitale
                          </li>
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Optimisation des processus
                          </li>
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Gestion du changement
                          </li>
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Formation et accompagnement
                          </li>
                          <li>
                            <i class="fas fa-check text-success me-2"></i>
                            Suivi et amélioration continue
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 mt-4 mt-lg-0">
                    <img src="@/assets/img/nconsulting-illustration.jpeg" alt="N'Consulting expertise" class="w-100 border-radius-lg shadow-lg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 mb-4">
            <div class="card">
              <div class="card-body p-3">
                <h5 class="font-weight-bolder mb-4">Notre approche</h5>
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-compass-04 text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>Analyse approfondie</h6>
                        <p>Compréhension détaillée de vos besoins et objectifs</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-settings text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>Solutions sur mesure</h6>
                        <p>Recommandations adaptées à votre contexte</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-user-run text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>Accompagnement continu</h6>
                        <p>Support tout au long de la transformation</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <testimonials-section />
    
    <!-- FAQ Section -->
    <faq-section />

    <!-- Final CTA Section -->
    <cta-section />

    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import PageHero from '@/components/PageHero.vue';
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';
import CtaSection from '@/components/CtaSection.vue';

export default {
  name: 'AboutNConsulting',
  components: {
    Navbar,
    AppFooter,
    PageHero,
    TestimonialsSection,
    FaqSection,
    CtaSection
  }
}
</script>

<style scoped>
/* Styles propres à N'Consulting si nécessaire */
</style>